import axios from "../../axiosInstance";
import requests from '../../requests';

import { takeLatest, all, put, call, delay } from "redux-saga/effects";

import { canvasActionTypes } from "./canvas.types";
import {
	fetchDiagramMembers,
	fetchDiagramMembersSuccess,
	fetchDiagramMembersFailure,

	changeRoleForDiagramMemberSuccess,
	changeRoleForDiagramMemberFailure,

	removeDiagramMemberSuccess,
	removeDiagramMemberFailure,

	fetchDiagramInvites,
	fetchDiagramInvitesSuccess,
	fetchDiagramInvitesFailure,

	createDiagramInviteSuccess,
	createDiagramInviteFailure,

	revokeDiagramInviteSuccess,
	revokeDiagramInviteFailure,
} from "./canvas.actions";

import { showNotify } from "../notify/notify.actions";

export function* fetchDiagramMembersRequest({ payload: { diagramId } }) {
	try {
		const url = `${requests.diagrams}/${diagramId}/members`;
		const { data, error } = yield axios.get(url, {});

		if (error) {
			yield put(fetchDiagramMembersFailure(error));
		} else {
			yield put(fetchDiagramMembersSuccess(data));
		}
	} catch (e) {
		yield put(fetchDiagramMembersFailure(e));
	}
}

export function* changeRoleForDiagramMemberRequest({ payload: { diagramId, memberId, newRole } }) {
	try {
		yield put(showNotify({ message: 'Changing...' }));

		const url = `${requests.diagrams}/${diagramId}/members/${memberId}/role`;
		const { data, error } = yield axios.post(url, { role: newRole });
		if (error) {
			yield put(changeRoleForDiagramMemberFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(changeRoleForDiagramMemberSuccess());
			yield put(showNotify({ message: 'The role has been changed' }));
			yield put(fetchDiagramMembers(diagramId));
		}
	} catch (e) {
		yield put(changeRoleForDiagramMemberFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* removeDiagramMemberRequest({ payload: { diagramId, memberId } }) {
	try {
		yield put(showNotify({ message: 'Removing...' }));

		const url = `${requests.diagrams}/${diagramId}/members/${memberId}`;
		const { data, error } = yield axios.delete(url, {});
		if (error) {
			yield put(removeDiagramMemberFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(removeDiagramMemberSuccess());
			yield put(showNotify({ message: 'The member has been removed' }));
			yield put(fetchDiagramMembers(diagramId));
		}
	} catch (e) {
		yield put(removeDiagramMemberFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* fetchDiagramInvitesRequest({ payload: { diagramId } }) {
	try {
		const url = `${requests.diagrams}/${diagramId}/invites`;
		const { data, error } = yield axios.get(url, {});

		if (error) {
			yield put(fetchDiagramInvitesFailure(error));
		} else {
			yield put(fetchDiagramInvitesSuccess(data));
		}
	} catch (e) {
		yield put(fetchDiagramInvitesFailure(e));
	}
}

export function* createDiagramInviteRequest({ payload: { diagramId, email, role } }) {
	try {
		yield put(showNotify({ message: 'Inviting...' }));

		const url = `${requests.diagrams}/${diagramId}/invite`;
		const { data, error } = yield axios.post(url, { email, role });
		if (error) {
			yield put(createDiagramInviteFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(createDiagramInviteSuccess());
			yield put(showNotify({ message: 'The invitation has been sent' }));
			yield put(fetchDiagramInvites(diagramId));
		}
	} catch (e) {
		yield put(createDiagramInviteFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* revokeDiagramInviteRequest({ payload: { diagramId, inviteId } }) {
	try {
		yield put(showNotify({ message: 'Removing...' }));

		const url = `${requests.diagrams}/${diagramId}/invites/${inviteId}/revoke`;
		const { data, error } = yield axios.post(url, {});
		if (error) {
			yield put(revokeDiagramInviteFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(revokeDiagramInviteSuccess());
			yield put(showNotify({ message: 'The invitation has been removed' }));
			yield put(fetchDiagramInvites(diagramId));
		}
	} catch (e) {
		yield put(revokeDiagramInviteFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* onFetchDiagramMembers() {
	yield takeLatest(canvasActionTypes.FETCH_DIAGRAM_MEMBERS_REQUEST, fetchDiagramMembersRequest);
}
export function* onChangeRoleForDiagramMember() {
	yield takeLatest(canvasActionTypes.CHANGE_MEMBER_ROLE_REQUEST, changeRoleForDiagramMemberRequest);
}
export function* onRemoveDiagramMember() {
	yield takeLatest(canvasActionTypes.REMOVE_DIAGRAM_MEMBER_REQUEST, removeDiagramMemberRequest);
}
export function* onFetchDiagramInvites() {
	yield takeLatest(canvasActionTypes.FETCH_DIAGRAM_MEMBERS_REQUEST, fetchDiagramInvitesRequest);
}
export function* onCreateDiagramInviteRequest() {
	yield takeLatest(canvasActionTypes.CREATE_DIAGRAM_INVITE_REQUEST, createDiagramInviteRequest);
}
export function* onRevokeDiagramInviteRequest() {
	yield takeLatest(canvasActionTypes.REVOKE_DIAGRAM_INVITE_REQUEST, revokeDiagramInviteRequest);
}

export function* canvasSagas() {
	yield all
		([
			call(onFetchDiagramMembers),
			call(onChangeRoleForDiagramMember),
			call(onRemoveDiagramMember),

			call(onFetchDiagramInvites),
			call(onCreateDiagramInviteRequest),
			call(onRevokeDiagramInviteRequest),
		]);
}